import React from "react";

import { useUser } from "@components/user-context";
import { type DataTypeProvider } from "@devexpress/dx-react-grid";
import { formatMetric } from "@north-beam/nb-common/formatting";

import {
  type TableRowTypeData,
  type TableRowType,
} from "../mid-cycle-rebudgeting-table";

import { MetricsSection } from "./metrics-section";

export const MetricDataFormatter = ({
  column,
  row: _row,
}: DataTypeProvider.ValueFormatterProps) => {
  const { user } = useUser();
  const row = _row as TableRowType;
  const columnDef = column as any;

  const value = Number(row.data[columnDef.name as keyof TableRowTypeData]);
  const formatted = formatMetric(value, columnDef.format, {
    precision: "exact",
    code: user.currencies.currentCurrency,
  });

  return (
    <div className="flex items-center justify-between h-full px-2 overflow-hidden">
      {row?.isHeaderRow && columnDef.loading && (
        <div className="animate-pulse flex-grow w-full">
          <div className="h-2 w-2/5 bg-gray-2"></div>
        </div>
      )}
      <MetricsSection className="flex-grow" value={formatted} />
    </div>
  );
};
